<div class="page-container ui-surface-page ui-page-shell-modern">
  <div *ngIf="isLoading" class="lot-skeleton-block">
    <app-skeleton variant="card" [lines]="4"></app-skeleton>
    <app-skeleton variant="card" [lines]="3" *ngFor="let item of [1, 2]"></app-skeleton>
  </div>

  <div *ngIf="!isLoading && loadError" class="load-state-card load-state-card-error">
    <strong>Não foi possível carregar o lote</strong>
    <span>{{ loadError }}</span>
    <button class="btn btn-primary" type="button" (click)="getBatchDetails()">Tentar novamente</button>
  </div>

  <ng-container *ngIf="!isLoading && batch && !loadError">
  <div *ngIf="batch.IntegrationError" class="return-banner">
    <span><strong>Retorno: </strong>{{ batch.IntegrationMsg || '-' }}</span>
  </div>

  <!-- KPI Card -->
  <div class="kpi-card lot-header-card">
    <div class="lot-header-topline">
      <span class="lot-header-number">Lote {{ batch.BatchNumber }}</span>
    </div>

    <div class="details-summary-grid">
      <div class="summary-field">
        <span class="summary-label">STATUS DO LOTE</span>
        <span class="summary-status status-badge" [ngClass]="getStatusClass(batch.StatusOfOnlending)">
          {{ batch.StatusOfOnlending || '-' }}
        </span>
      </div>

      <div class="summary-field">
        <span class="summary-label">DATA DO LOTE</span>
        <span class="summary-value">{{ batch.CreateDate | systemDate:'dd/MM/yyyy' }}</span>
      </div>

      <div class="summary-field">
        <span class="summary-label">DATA E-MAIL PGTO</span>
        <span class="summary-value" [class.summary-value-muted]="!batch.EmailEstimatedPaymentDate">
          {{ batch.EmailEstimatedPaymentDate ? (batch.EmailEstimatedPaymentDate | date:'dd/MM/yyyy') : '—' }}
        </span>
      </div>

      <div class="summary-field">
        <span class="summary-label">QTDE CONTRATOS</span>
        <span class="summary-value">{{ batchContractsCount }}</span>
      </div>

      <div class="summary-field">
        <span class="summary-label">VL. TOTAL FINANCIAMENTO</span>
        <span class="summary-value summary-value--brand">{{ batchTotalAmount | currency:'BRL' }}</span>
      </div>

      <div class="summary-field">
        <span class="summary-label">VALOR DO REPASSE</span>
        <span class="summary-value summary-value--brand">{{ batchTotalTransferAmount | currency:'BRL' }}</span>
      </div>

      <div class="summary-field">
        <span class="summary-label">VL. TOTAL ESTORNO</span>
        <span class="summary-value" [class.summary-value--danger]="(batch.TotalReversed || 0) > 0">
          {{ (batch.TotalReversed || 0) | currency:'BRL' }}
        </span>
      </div>

      <div class="summary-field summary-field--partners">
        <span class="summary-label">PARCEIROS</span>
        <div class="summary-partners">
          <!-- <span class="summary-pill summary-pill--master" *ngIf="masterPartnersCount > 0">
            {{ masterPartnersCount }} Master{{ masterPartnersCount > 1 ? 's' : '' }}
          </span>
          <span class="summary-pill summary-pill--subs" *ngIf="substabelecidoPartnersCount > 0">
            {{ substabelecidoPartnersCount }} Subest.
          </span> -->
          <span class="section-count-pill section-count-pill--master" *ngIf="masterPartnersCount > 0">
            <span class="pill-dot"></span>{{ masterPartnersCount }} Master{{ masterPartnersCount > 1 ? 's' : '' }}
          </span>
          <span class="section-count-pill section-count-pill--subs" *ngIf="substabelecidoPartnersCount > 0">
            <span class="pill-dot"></span>{{ substabelecidoPartnersCount }} Subest.{{ substabelecidoPartnersCount > 1 ? 's' : '' }}
          </span>
        </div>
      </div>
    </div>

    <div class="details-observation-row">
      <label class="summary-label" for="batch-observacao">OBSERVAÇÃO:</label>
      <input
        id="batch-observacao"
        class="details-observation-input"
        [formControl]="observacao"
        type="text"
        placeholder="Digite uma observação..." />
      <button class="details-observation-save" type="button" (click)="saveObservation()" aria-label="Salvar observação">
          <app-svg-icon src="assets/icons/save-icon.svg" width="14px" height="14px"></app-svg-icon>
      </button>
    </div>

  </div>
  
  <div class="section-header">
    <div class="section-header-left">
      <!-- <h2 class="section-header-title">Beneficiários do Lote</h2> -->
      <!-- <span class="section-count-pill section-count-pill--master" *ngIf="masterPartnersCount > 0">
        <span class="pill-dot"></span>{{ masterPartnersCount }} Master{{ masterPartnersCount > 1 ? 's' : '' }}
      </span>
      <span class="section-count-pill section-count-pill--subs" *ngIf="substabelecidoPartnersCount > 0">
        <span class="pill-dot"></span>{{ substabelecidoPartnersCount }} Substabelecido{{ substabelecidoPartnersCount > 1 ? 's' : '' }}
      </span> -->
    </div>
    <div class="section-header-actions">
      <button class="btn btn-header" type="button" matTooltip="Ver o e-mail de pagamento de cada sublote, sem enviar" (click)="openEmailPreview(true)">
        <app-svg-icon src="assets/icons/view-icon.svg" width="15px" height="15px"></app-svg-icon>
        Prévia E-mail Pgto
      </button>
      <button class="btn btn-header" type="button" (click)="handleSendingTransferBatchEmail(true)">
        <app-svg-icon src="assets/icons/finance-email.svg" width="15px" height="15px"></app-svg-icon>
        E-mail Pgto Lote
      </button>
      <button class="btn btn-header" type="button" matTooltip="Ver o e-mail de cada sublote, sem enviar" (click)="openEmailPreview(false)">
        <app-svg-icon src="assets/icons/view-icon.svg" width="15px" height="15px"></app-svg-icon>
        Prévia E-mail Lote
      </button>
      <button class="btn btn-header btn-header-accent" type="button" [disabled]="disableSendTransferBatchEmail" (click)="handleSendingTransferBatchEmail(false)">
        <app-svg-icon src="assets/icons/email-icon.svg" width="15px" height="15px"></app-svg-icon>
        E-mail Lote
      </button>
      <button *ngIf="contractsToExclude.length > 0" class="btn btn-danger" type="button" (click)="openDeleteContractsModal()">
        <app-svg-icon src="assets/icons/trash-icon.svg" width="13px" height="13px"></app-svg-icon>
        Excluir ({{ contractsToExclude.length }})
      </button>
      <button *ngIf="showRpaButton" class="btn btn-secondary" type="button" (click)="generateRPA()">
        <app-svg-icon src="assets/icons/file-icon.svg" width="13px" height="13px"></app-svg-icon>
        Gerar RPA
      </button>
      <label *ngIf="showRpaButton" class="iss-toggle" [class.iss-toggle--disabled]="issUpdating">
        <input type="checkbox" [checked]="batch.CalcularIss" [disabled]="issUpdating" (change)="onCalcularIssChange($event)" />
        <span class="iss-toggle-slider"></span>
        <span class="iss-toggle-label">Calcular ISS</span>
      </label>
      <button *ngIf="!batchBlocked" class="btn btn-primary" type="button" (click)="openContractListDialog()">
        <app-svg-icon src="assets/icons/plus-icon.svg" width="13px" height="13px"></app-svg-icon>
        Adicionar Contratos
      </button>
    </div>
  </div>
  
  <div class="sublotes-section">

    <div *ngIf="batch.Partners!.length === 0" class="empty-state">
      <app-empty-card text="Não há contratos adicionados!" height="50px"></app-empty-card>
    </div>

    <div class="beneficiarios-wrapper">

      <!-- Beneficiário Principal (Master) -->
      <div class="master-block" *ngIf="masterPartner">
        <!-- <div class="beneficiario-role-label beneficiario-role-label--master">
          <span class="role-dot"></span>
          Beneficiário Principal
        </div> -->
        <app-sublote-card-v2
          [partner]="masterPartner"
          [index]="batch.Partners!.indexOf(masterPartner)"
          [batchBlocked]="batchBlocked"
          [parentBatchNumber]="batch.BatchNumber.toString()"
          [productsById]="productsById"
          [serviceCodes]="serviceCodes"
          [recalculating]="isRecalculating(masterPartner)"
          [integratedSubestabelecidoContractIds]="integratedSubestabelecidoContractIds"
          [selectedContractIdsToExclude]="selectedContractIdsToExclude"
          (deleteContractEvent)="handleDeleteContract($event)"
          (cancelSubBatchEvent)="cancelSubBatch($event)"
          (serviceCodeChangeEvent)="handleServiceCodeChange($event)"
          (integrateSapEvent)="integrateSapPartner($event)"
          (liberarManualEvent)="liberarManualEvent($event)"
          (sendEmailEvent)="handleSendingTransferBatchEmail($event.paymentEmail, $event.partnerId)"
          (previewEmailEvent)="openEmailPreview($event.paymentEmail, $event.partnerId)">
        </app-sublote-card-v2>
      </div>

      <!-- Substabelecidos -->
      <div class="substabelecidos-block" *ngIf="substabelecidoPartners.length">
        <div class="subs-connector" aria-hidden="true"></div>
        <div class="subs-inner">
          <!-- <div class="beneficiario-role-label beneficiario-role-label--subs">
            <span class="role-dot"></span>
            Substabelecidos
            <span class="subs-count">{{ substabelecidoPartners.length }}</span>
          </div> -->
          <ng-container *ngFor="let partner of substabelecidoPartners; trackBy: trackByPartner">
            <app-sublote-card-v2
              [partner]="partner"
              [index]="batch.Partners!.indexOf(partner)"
              [batchBlocked]="batchBlocked"
              [parentBatchNumber]="batch.BatchNumber.toString()"
              [productsById]="productsById"
              [serviceCodes]="serviceCodes"
              [recalculating]="isRecalculating(partner)"
              [integratedSubestabelecidoContractIds]="integratedSubestabelecidoContractIds"
              [selectedContractIdsToExclude]="selectedContractIdsToExclude"
              (deleteContractEvent)="handleDeleteContract($event)"
              (cancelSubBatchEvent)="cancelSubBatch($event)"
              (serviceCodeChangeEvent)="handleServiceCodeChange($event)"
              (integrateSapEvent)="integrateSapPartner($event)"
              (liberarManualEvent)="liberarManualEvent($event)"
              (sendEmailEvent)="handleSendingTransferBatchEmail($event.paymentEmail, $event.partnerId)"
          (previewEmailEvent)="openEmailPreview($event.paymentEmail, $event.partnerId)">
            </app-sublote-card-v2>
          </ng-container>
        </div>
      </div>

    </div>
  </div>

  <!-- ── Footer ────────────────────────────────────────────────────────────── -->
  <app-contratos-footer-v2
    *ngIf="batch"
    [batchId]="batch.BatchId.toString()"
    [allowIntegrationSap]="allowIntegrationSap"
    [allowCancelBatch]="allowCancelBatch"
    [allowReturnStatus]="allowReturnStatus"
    (cancelBatchEvent)="handleCancelBatchEvent()"
    (returnBatchStatusEvent)="handleReturnBatchStatusEvent()"
    (viewBatchEventLogEvent)="getBatchEventLogs()"
    (integrateSapEvent)="integrateSap()">
  </app-contratos-footer-v2>
  </ng-container>
</div>

